<script context="module">
    export const MFAType = [
        { id: 0, type: "None" },
        { id: 1, type: "Email" },
        { id: 2, type: "Sms" },
        { id: 3, type: "App Notification" },
        { id: 4, type: "Google Authenticator" },
    ];

    export const BillingStatus = [
        { id: 0, type: "Pre Quote", color: "#FF00A8" },
        { id: 1, type: "Quoted", color: "#FBD408" },
        { id: 2, type: "Ready", color: "#2662F0" },
        { id: 3, type: "Submitted", color: "#14B8C2" },
        { id: 4, type: "In Progress", color: "#AD00FF" },
        { id: 5, type: "Completed", color: "#07D003" },
    ];

    export const DirectBillingStatus = {
        PreQuote: 0,
        Quoted: 1,
        Ready: 2,
        Submitted: 3,
        InProgress: 4,
        Completed: 5,
    };

    export const QuoteStatuses = [
        { id: 0, type: "Pre Estimate", color: "#FF00A8" },
        { id: 1, type: "Estimate Sent", color: "#FBD408" },
        { id: 2, type: "Rejected", color: '#C21414'},
        { id: 3, type: "Approved", color: '#158E41'},
        { id: 5, type: "Completed" },
    ];

    export const QuoteBillingStatus = [
        { id: 1, type: "Created" },
        { id: 2, type: "Accepted" },
        { id: 5, type: "Rejected" },
        { id: 9, type: "Cancelled" },
    ];

    export const BillingType = [
        { id: 0, type: "None" },
        { id: 1, type: "No Gap Fee" },
        { id: 2, type: "Set Unit Value" },
        { id: 3, type: "Set Gap Fee" },
        { id: 4, type: "Set Hourly Rate" },
        { id: 5, type: "Set Total Fee" },
        { id: 6, type: "Set MBS Fee Percentage" },
        { id: 7, type: "Set DVA Fee Percentage" },
        { id: 8, type: "Set BUPA Schedule fee percentage" },
        { id: 9, type: "Set AHSA Schedule fee percentage" },
        { id: 10, type: "Set Medibank Schedule fee percentage" },
        { id: 11, type: "Set NIB Schedule fee percentage" },
        { id: 12, type: "Set HCF Schedule fee percentage" },
        { id: 13, type: "Set AMA Schedule fee percentage" },
    ];

    export const InvoiceReasons = [
        { id: 1, type: "Record" },
        { id: 2, type: "PaymentDue" },
        { id: 3, type: "TopUp" },
        { id: 4, type: "Refund" },
        { id: 5, type: "InsuranceUnderpayment" },
        { id: 6, type: "InsuranceDeclined" },
    ];

    export const BillingItemCodeType = [
        { id: 0, type: "MBS" },
        { id: 1, type: "ASA" },
        { id: 2, type: "FreeText" },
    ];

    export const OOPType = [
        { id: 0, type: "Pre Pay" },
        { id: 1, type: "Post Pay" },
    ];

    export const GenderType = [
        { id: 0, type: "Male" },
        { id: 1, type: "Female" },
        { id: 2, type: "Not Specified" },
    ];

    // sync start
    export const InsuranceType = [
        { id: 0, type: "Private", order: 1 },
        { id: 10, type: "Overseas cover", order: 3, shortTitle: "Overseas" },
        { id: 11, type: "Self insured", order: 2 },
        { id: 15, type: "Cosmetic", order: 4, shortTitle: "Cosmetics" },
        {
            id: 16,
            type: "Workers Compensation",
            order: 6,
            shortTitle: "WorkCover",
        },
        { id: 17, type: "Traffic Accident", order: 7, shortTitle: "Traffic" },
        { id: 18, type: "3rd Party Payer", order: 11, shortTitle: "3rd Party" },
        { id: 20, type: "DVA", order: 5 },
        // { id: 25, type: "Defence (BUPA)",},
        // { id: 26, type: "Defence (AMA)", },
        {
            id: 25,
            type: "Australian Defence Force (BUPA)",
            order: 8,
            shortTitle: "ADF Bupa",
        },
        {
            id: 26,
            type: "Australian Defence Force (AMA)",
            order: 9,
            shortTitle: "ADF AMA",
        },
        { id: 30, type: "Public in Private", order: 10, shortTitle: "PIP" },
    ];

    export const DirectInsuranceType = {
        Private: 0,
        Overseascover: 10,
        SelfInsured: 11,
        Cosmetic: 15,
        WorkersCompensation: 16,
        TrafficAccident: 17,
        ThirdPartyInsurer: 18,
        DVA: 20,
        DefenceBupa: 25,
        DefenceAMA: 26,
        PublicInPrivate: 30,
    };

    export const PatientPayInsuranceTypes = [
        DirectInsuranceType.Private,
        DirectInsuranceType.Overseascover,
        DirectInsuranceType.SelfInsured,
        DirectInsuranceType.Cosmetic,
    ];
    // sync end

    export const EncounterConsentType = [
        { id: 1, type: "Rejected or Ignored", order: 1 },
        { id: 2, type: "Rejected", order: 2 },
        { id: 3, type: "Ignored", order: 3 },
    ];

    export const doctorsHealthCoverType = [
        { key: "Normal Cover", value: "Prime Choice Gold (AHSA RVGs)" },
        { key: "Top Cover", value: "Top Cover Gold (AMA RVGs)" },
    ];

    export const australianUnityCoverTypes = [
        { key: "Basic Plus", value: "Basic Plus" },
        { key: "Core/Standard", value: "Core/Standard" },
    ];

    export const RoleType = [
        { id: 0, type: "NONE" },
        { id: 1, type: "Patient" },
        { id: 2, type: "Doctor" },
        { id: 20, type: "Support" },
        { id: 80, type: "Manager" },
        { id: 90, type: "Developer" },
        { id: 100, type: "Admin" },
    ];

    export const RuleType = [
        { id: 0, type: "NONE" },
        { id: 1, type: "No Gap" },
        { id: 2, type: "Unit Value" },
        { id: 3, type: "Out Of Pocket" },
        { id: 4, type: "Hourly Rate" },
        { id: 5, type: "Total Fee" },
        { id: 6, type: "Set MBS schedule fee percentage" },
        { id: 7, type: "Set DVA Fee Percentage" },
        { id: 8, type: "Set BUPA Schedule fee percentage" },
        { id: 9, type: "Set AHSA Schedule fee percentage" },
        { id: 10, type: "Set Medibank Schedule fee percentage" },
        { id: 11, type: "Set NIB Schedule fee percentage" },
        { id: 12, type: "Set HCF Schedule fee percentage" },
        { id: 13, type: "Set AMA Schedule fee percentage" },
    ];

    export const TaskStatus = [
        { id: 0, type: "Not Completed" },
        { id: 0, type: "Completed" },
    ];

    export const TitleType = [
        { id: 0, type: "Mr" },
        { id: 1, type: "Mrs" },
        { id: 2, type: "Ms" },
        { id: 3, type: "Miss" },
        { id: 4, type: "Master" },
        { id: 5, type: "Dr" },
        { id: 6, type: "Prof" },
        { id: 7, type: "A/Prof" },
        { id: 20, type: "Other" },
    ];

    export const DoctorTitleTypes = [
        { id: 5, type: "Dr" },
        { id: 6, type: "Prof" },
        { id: 7, type: "A/Prof" },
        { id: 2, type: "Ms" },
        { id: 0, type: "Mr" },
    ];

    // sync start
    export const UserStatus = [
        { id: 0, type: "Active" },
        { id: 1, type: "Inactive" },
        { id: 8, type: "Blocked" },
        { id: 9, type: "Deleted" },
    ];

    export const DirectUserStatuses = {
        Active: 0,
        Inactive: 1,
        Blocked: 8,
        Deleted: 9,
    };
    // sync end

    export const ForgotPasswordStatus = [
        { id: 0, type: "Request" },
        { id: 1, type: "Reset" },
    ];

    export const HospitalType = [
        // { id: 0, type: "NONE" },
        { id: 1, type: "Private" },
        { id: 2, type: "Public" },
    ];

    export const LogActionType = [
        { id: 0, type: "NONE" },
        { id: 1, type: "Post" },
        { id: 2, type: "Get" },
        { id: 3, type: "Update" },
        { id: 4, type: "Delete" },
    ];

    export const EstimatePaidForType = [
        { id: 0, type: "Quote" },
        { id: 1, type: "Invoice" },
    ];

    export const EstimatePaidByType = [
        { id: 0, type: "Patient" },
        { id: 1, type: "Insurance" },
        { id: 2, type: "Health Fund" },
    ];

    export const EstimatePaidMethodType = [
        { id: 0, type: "EFT" },
        { id: 1, type: "Credit Card" },
    ];

    export const pageOptions = [
        { id: 1, amount: Number(10) },
        { id: 2, amount: Number(25) },
        { id: 3, amount: Number(50) },
        { id: 4, amount: Number(100) },
    ];

    export const opvStatusMedicare = [
        { id: 0, type: "Not Checked" },
        { id: 1, type: "Success" },
        { id: 2, type: "Failure" },
        { id: 3, type: "No Response from Medicare" },
    ];

    export const opvStatusDVA = [
        { id: 0, type: "Not Checked" },
        { id: 1, type: "Success" },
        { id: 2, type: "Failure" },
        { id: 3, type: "No Response from DVA" },
    ];

    export const opvStatusHealthFund = [
        { id: 0, type: "Not Checked" },
        { id: 1, type: "Success" },
        { id: 2, type: "Failure" },
    ];

    export const eligibilityStatusMedicare = [
        { id: 0, type: "Not Checked" },
        { id: 1, type: "Success" },
        { id: 2, type: "Failure" },
    ];

    export const eligibilityStatusHealthFund = [
        { id: 0, type: "Not Checked" },
        { id: 1, type: "Success" },
        { id: 2, type: "Failure" },
    ];

    export const claimStatus = [
        {
            id: 0,
            type: "Pending",
            color: "#6E6893",
            progressOrder: 1,
            bgColor: "#E6E6F2",
        },
        {
            id: 1,
            type: "Failed",
            color: "#D30000",
            progressOrder: 4,
            bgColor: "#FFE0E0",
        },
        {
            id: 2,
            type: "Submitted",
            color: "#4A4AFF",
            progressOrder: 2,
            bgColor: "#E6E6F2",
        },
        {
            id: 3,
            type: "Success",
            color: "#2CC09C",
            progressOrder: 5,
            bgColor: "#CDFFCD",
        },
        {
            id: 5,
            type: "Rejected",
            color: "#D30000",
            progressOrder: 3,
            bgColor: "#FFE0E0",
        },
        {
            id: 10,
            type: "No Need to Claim",
            color: "#6E6893",
            progressOrder: 0,
            bgColor: "#E4E4E4",
        },
    ];

    export const DirectClaimStatus = {
        Pending: 0,
        Failed: 1,
        Submitted: 2,
        Success: 3,
        Rejected: 5,
        NoNeedToClaim: 10,
    };

    export const claimERAStatus = [
        { id: 0, type: "Pending" },
        { id: 1, type: "Complete" },
        { id: 2, type: "Failed" },
        { id: 3, type: "In Progress" },
        { id: 10, type: "Stopped" },
    ];

    export const dashboardFilterIntervals = [
        { id: 0, type: "Last month" },
        { id: 1, type: "Last 3 months" },
        { id: 2, type: "Last 6 months" },
        { id: 3, type: "Last year" },
        { id: 4, type: "Custom" },
        { id: 5, type: "Current month" },
        { id: 6, type: "Current year" },
    ];

    // sync start
    export const paymentStatus = [
        { id: 0, type: "Pending" },
        { id: 1, type: "Received" },
        { id: 2, type: "Received Externally" },
        { id: 4, type: "Pending refund" },
        { id: 5, type: "Refunded" },
        { id: 7, type: "Write Off" },
        { id: 9, type: "Cancelled" },
    ];

    export const DirectPaymentStatus = {
        Pending: 0,
        Received: 1,
        ReceivedExternally: 2,
        PendingRefund: 4,
        Refunded: 5,
        WriteOff: 7,
        Cancelled: 9,
    };
    // sync end

    // sync start
    export const doctorStatus = [
        { id: 0, type: "Active" },
        { id: 1, type: "Demo" },
        { id: 5, type: "New (Unverified)" },
        { id: 8, type: "Blocked" },
        { id: 9, type: "Deleted" },
    ];

    export const DirectDoctorStatus = {
        Active: 0,
        Demo: 1,
        NewUnverified: 5,
        Blocked: 8,
        Deleted: 9,
    };
    // sync end

    export const AustralianStates = [
        { name: "Australian Capital Territory", key: "ACT" },
        { name: "New South Wales", key: "NSW" },
        { name: "Northern Territory", key: "NT" },
        { name: "Queensland", key: "QLD" },
        { name: "South Australia", key: "SA" },
        { name: "Victoria", key: "VIC" },
        { name: "Tasmania", key: "TAS" },
        { name: "Western Australia", key: "WA" },
    ];

    export const DirectUserRoles = {
        Admin: 100,
        Developer: 90,
        Manager: 80,
        Support: 20,
        Doctor: 2,
        Patient: 1,
    };
    // sync end

    export const authenticatorTypes = [
        { id: 2, type: "SMS" },
        {
            id: 3,
            type: "Mobile Notification",
            visibleUserRole: [DirectUserRoles.Doctor],
        },
        { id: 4, type: "Google Authenticator" },
    ];

    export const providerBupaStatus = [
        { id: true, type: "No Gap" },
        { id: false, type: "Known Gap" },
    ];

    export const providerHcfStatus = [
        { id: true, type: "No Gap" },
        { id: false, type: "Known Gap" },
    ];

    export const providerNibStatus = [
        { id: true, type: "Medigap" },
        { id: false, type: "GapSure" },
    ];

    export const activityLogsActionType = [
        { id: 1, type: "Create" },
        { id: 2, type: "Get" },
        { id: 3, type: "Update" },
        { id: 4, type: "Delete" },
    ];

    export const announcementsType = [{ id: 0, type: "What's New" }];

    export const encounterBillingType = [
        { id: 0, type: "Anaesthesia" },
        // { id: 1, type: "Postop Consult" },
        { id: 1, type: "Consults & Attendances" },
        { id: 2, type: "Labour Epidural" },
        { id: 3, type: "Cardiac Surgery" },
    ];

    export const encounterNeuraxialType = [
        { id: 0, type: "No Value" },
        { id: 1, type: "Insertion" },
        { id: 2, type: "Topup" },
    ];

    // sync start
    export const encounterStatus = [
        { id: 0, type: "Active", color: "#4A4AFF", bgColor: "#E6E6F2" },
        { id: 1, type: "On Hold", color: "#965E00", bgColor: "#FFECCC" },
        {
            id: 5,
            type: "Debt Collection",
            color: "#D30000",
            bgColor: "#FFECCC",
        },
        {
            id: 7,
            type: "Pending Cancellation",
            color: "#6E6893",
            bgColor: "#FFE0E0",
        },
        { id: 8, type: "Cancelled", color: "#D30000", bgColor: "#FFE0E0" },
        { id: 9, type: "Archived", color: "#D30000", bgColor: "#E6E6F2" },
    ];

    export const DirectEncounterStatus = {
        Active: 0,
        OnHold: 1,
        DebtCollection: 5,
        PendingCancellation: 7,
        Cancelled: 8,
        Archived: 9,
    };
    // sync end

    // sync start
    export const userRoles = [
        { id: 100, type: "Admin" },
        { id: 90, type: "Developer" },
        { id: 80, type: "Manager" },
        { id: 20, type: "Support" },
        { id: 2, type: "Doctor" },
        { id: 1, type: "Patient" },
    ];

    export const defaultState = "VIC";

    export const months = [
        { id: 0, name: "January" },
        { id: 1, name: "February" },
        { id: 2, name: "March" },
        { id: 3, name: "April" },
        { id: 4, name: "May" },
        { id: 5, name: "June" },
        { id: 6, name: "July" },
        { id: 7, name: "August" },
        { id: 8, name: "September" },
        { id: 9, name: "October" },
        { id: 10, name: "November" },
        { id: 11, name: "December" },
    ];

    export const estimateStatus = [
        { id: 1, type: "Created" },
        { id: 2, type: "Sent" },
        { id: 4, type: "Patient Approved" },
        { id: 5, type: "Patient Rejected" },
        { id: 9, type: "Cancelled" },
    ];

    export const invoiceStatus = [
        { id: 1, type: "Created" },
        { id: 2, type: "Sent" },
        { id: 9, type: "Cancelled" },
    ];

    // sync start
    // doctor specific used for create doctor event and create events from calendar
    export const accountCalendarEventType = [
        {
            id: 0,
            type: "Leave",
            order: 3,
            doctorSpecific: true,
            creatableFromCalendar: true,
        },
        {
            id: 1,
            type: "List",
            order: 1,
            doctorSpecific: true,
            creatableFromCalendar: true,
        },
        {
            id: 2,
            type: "On-call",
            order: 2,
            doctorSpecific: true,
            creatableFromCalendar: true,
        },
        {
            id: 5,
            type: "Global",
            order: 5,
            doctorSpecific: false,
            creatableFromCalendar: false,
        },
        {
            id: 6,
            type: "Public Holiday",
            order: 6,
            doctorSpecific: false,
            creatableFromCalendar: false,
        },
    ];

    export const CalendarEventCategoryTypes = {
        Leave: 0,
        List: 1,
        OnCall: 2,
        PatientEncounter: 3,
        Custom: 4,
        Global: 5,
        PublicHoliday: 6,
    };
    // sync end

    export const accountCalendarRepeatIntervalType = [
        { id: 0, type: "No Repeat" },
        { id: 1, type: "Day" },
        { id: 2, type: "Week" },
        { id: 3, type: "Month" },
        { id: 4, type: "Year" },
    ];

    export const presetRuleType = [
        { 
            id: 7, 
            type: "DoctorsHealthFundTopCover", 
            description: "Doctor’s Health Fund (Top Cover)", 
            info: "This will be applied only to Doctor’s Health Fund (Top Cover) encounters",
            group: "Private" 
        },
        { 
            id: 2, 
            type: "NIBGroupFunds", 
            description: "NIB group funds", 
            info: "This will be applied only to NIB group funds encounters. If the gap fee is capped at the maximum allowable gap, the maximum allowable gap will depend on whether the provider number used is signed up for NIB GapSure, and will take into account the surgical item base units",
            group: "Private" 
        },
        {
            id: 1,
            type: "PrivateFundUnitValueUnder35",
            description: "CDH, AUH (Basic)",
            backendName: "PrivateFundNoGap",
            info: "This will be applied only to CDH fund, and AUH (Basic) encounters, with no restrictions on maxmimum allowable gap.",
            group: "Private"
        },
        {
            id: 0,
            type: "PrivateFundUnitValueOver35",
            description: "All other funds",
            backendName: "PrivateFundKnownGap",
            info: "This will be applied to encounters with any fund except CDH, AUH Basic, NIB and AMA Top Cover",
            group: "Private"
        },
        { 
            id: 3, 
            type: "SelfInsured", 
            info: "This will be applied only to Self Insured encounters.",
            description: "Self insured" 
        },
        { 
            id: 8, 
            type: "OverseasWithFund", 
            info: "This will be applied only to Overseas encounters that have funds with ECLIPSE claiming (BUPA)",
            description: "Funds with ECLIPSE claiming (BUPA)",
            group: "Overseas"  
        },
        { 
            id: 4, 
            type: "Overseas", 
            info: "This will be applied only to Overseas encounters with Other funds",
            description: "Other funds",
            group: "Overseas" 
        },
        {
            id: 5,
            type: "CosmeticAndThirdParty",
            info: "This will be applied only to Cosmetic & Third Party encounters.",
            description: "Cosmetic & Third Party",
        },
        { 
            id: 6, 
            type: "NonPreferedADF", 
            info: "This will be applied only to Non-preferred ADF encounters.",
            description: "Non-preferred ADF" 
        },
    ];

    export const handOverType = [
        { id: 0, type: "None", dropdownType: "Ready" },
        { id: 1, type: "Quote", dropdownType: "Handed Over - Quote" },
        { id: 2, type: "Invoice", dropdownType: "Handed Over - Invoice" },
        { id: 3, type: "Review", dropdownType: "Pending Review" },
    ];

    export const EditRepeatingEventOptions = {
        thisOnly: 1,
        thisAndFollowing: 2,
        allEvents: 3,
    };

    export const DeleteRepeatingEventOptions = {
        thisOnly: 1,
        thisAndFollowing: 2,
        allEvents: 3,
    };

    export const userFilterTypes = [
        {
            id: 0,
            type: "Doctors",
        },
    ];

    export const PdfTemplateTypes = {
        Estimate: 0,
        Invoice: 1,
        Receipt: 2,
        OnboardingTemplate: 3,
        EligibilityDisclaimer: 4,
        AccountInvoice: 5,
        AccountQuarterlyReport: 6,
        AccountAnnualReport: 7,
        TCIInternal: 8,
        PatientAttachedFile: 9,
        DB4BulkBillAssignment: 10,
        DVAServiceVoucher: 11,
        HealthFundInvoice: 12,
        TopUpInvoice: 13,
        ExternalGroupInvoice: 14,
        IMCPatientClaimConsent: 15,
        StatementOfClaimBenefit: 16,
        LodgementAdvice: 17,
        EventAttachedFile: 18,

        PdfLayout: 100,
    };

    export const CommunicationStatuses = {
        0: "Pending",
        1: "Sent",
        2: "Cancelled",
    };

    export const LogTypes = {
        Activity: "Activity",
        Eclipse: "Eclipse",
        Exception: "Exception",
        Login: "Login",
        Unauthorised: "Unauthorised",
    };

    export const PrivateInsuranceFundCoverType = [
        {
            id: 5,
            fundName: "Australian Unity Health Limited",
            coverTypes: [
                {
                    displayName: "Basic Plus",
                    value: "Basic Plus",
                    isDefault: true,
                },
                {
                    displayName: "Core/Standard",
                    value: "Core/Standard",
                },
            ],
        },
        {
            id: 13,
            fundName: "(The) Doctors' Health Fund Limited",
            coverTypes: [
                {
                    displayName: "Prime Choice Gold (AHSA RVGs)",
                    value: "Normal Cover",
                    isDefault: true,
                },
                {
                    displayName: "Top Cover (AMA RVGs)",
                    value: "Top Cover",
                },
            ],
        },
    ];

    export const paymentTag = [
        {
            id: 0,
            type: "Unknown",
        },
        {
            id: 1,
            type: "No Instructions Given",
            color: "#B2BAC9",
        },
        {
            id: 2,
            type: "No Payment Required",
            color: "#34ABD1",
        },
        {
            id: 3,
            type: "Requested Payment",
            color: "#FF00A8",
        },
        {
            id: 4,
            type: "Partial Payment",
            color: "#6B48FF",
        },
        {
            id: 5,
            type: "Fully Paid",
            color: "#2CC09C",
        },
    ];

    export const encounterPaymentDropdownOptions = [
        {
            id: 1,
            type: "Has Patient Payments",
            apiFilter: "filter[hasPatientPayments]",
        },
        {
            id: 2,
            type: "Has Health Fund Payments",
            apiFilter: "filter[hasInsurancePayments]",
        },
        {
            id: 3,
            type: "Has Payments",
            apiFilter: "filter[hasPayments]",
        },
    ];
</script>
